import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ReactComponent as TransactionIcon } from "../../assets/icon/clipboard-text.svg";
import { ReactComponent as SearchIcon } from "../../assets/icon/ri_search-line.svg";
import { ReactComponent as LogoDark } from "../../assets/logo_dark.svg";
import { ReactComponent as Logolight } from "../../assets/logo_light.svg";
import { isSideBar, searchAction } from '../../store/actions/todoActions';
import { useHandleClickLoading } from '../Common/utils';

import { ReactComponent as WalletIcon } from "../../assets/icon/account_balance_wallet.svg";
import { ReactComponent as BxsdiscountIcon } from "../../assets/icon/bxs_discount.svg";
import { ReactComponent as ProfileIcon } from "../../assets/icon/gg_profile.svg";
import { ReactComponent as LoginIcon } from "../../assets/icon/login.svg";
import { ReactComponent as LogoutIcon } from "../../assets/icon/material-symbols_logout.svg";
import { ReactComponent as MembershipIcon } from "../../assets/icon/membership.svg";
import { ReactComponent as PointIcon } from "../../assets/icon/money-finance.svg";
import { ReactComponent as RegisterIcon } from "../../assets/icon/register.svg";
import { ReactComponent as GiftCardIcon } from "../../assets/icon/ri_gift-line.svg";
import useDarkMode from '../Common/darkmode/DarkModeObserver';

const Sidebar = () => {
    const setSideBar = useSelector(state => state.todoReducer.isSideBar);
    const status = localStorage.getItem('isLogin');
    const isDarkMode = useDarkMode();
    const handleClickLoading = useHandleClickLoading();
    const [fill, setFill] = React.useState('#ffffff');
    const [hoveredIndex, setHoveredIndex] = useState(null);
    const dispatch = useDispatch();

    return (
        <div onClick={() => dispatch(isSideBar(false))}
            className={`w-full h-screen ${setSideBar ? 'translate-x-0 bg-[#021D3968] ' : '-translate-x-full bg-[#021D3900] '} transition-transform duration-300 ease-in-out fixed z-40`}>
            <div className={`flex flex-col bg-cardLight dark:bg-cardDark text-lightColor dark:text-darkColor items-start shadow-md w-[80%] p-3 max-w-xs h-screen ${setSideBar ? 'translate-x-0' : '-translate-x-full'} transition-transform duration-300 ease-in-out `}>
                <button onClick={() => { handleClickLoading('/') }} className='mb-3'>
                    {!isDarkMode ?
                        <Logolight className="sm:h-10 h-8 sm:max-w-[150px] max-w-[100px] " />
                        :
                        <Logolight className="sm:h-10 h-8 sm:max-w-[150px] max-w-[100px] " />
                    }
                </button>
                {status ?
                    [
                        { title: 'Pencarian', icon: SearchIcon, onClick: () => { dispatch(searchAction(true)) } },
                        { title: 'Cek Region Mobile Legends', icon: SearchIcon, onClick: () => { handleClickLoading('/check-ml'); } },

                        { title: 'Riwayat Transaksi', icon: TransactionIcon, onClick: () => { handleClickLoading('/history-order'); } },
                        { title: 'Membership', icon: MembershipIcon, onClick: () => { handleClickLoading('/membership'); } },
                        { title: 'Cek Pesanan', icon: TransactionIcon, onClick: () => { handleClickLoading('/cek-invoice'); } },
                        { title: 'Reedem Voucher', icon: BxsdiscountIcon, onClick: () => { handleClickLoading('/claim-voucher'); } },
                        { title: 'Gift Card', icon: GiftCardIcon, onClick: () => { handleClickLoading('/gift-card');} },
                        { title: 'Topup Saldo', icon: WalletIcon, onClick: () => { handleClickLoading('/topup'); } },
                        { title: 'Tukar Point', icon: PointIcon, onClick: () => { handleClickLoading('/tukarpoin') } },
                        { title: 'Log Saldo', icon: WalletIcon, onClick: () => { handleClickLoading('/logsaldo') } },
                        { title: 'Setting Profile', icon: ProfileIcon, onClick: () => { handleClickLoading('/me'); localStorage.setItem('isChoosePage', 'EditProfile'); } },
                        {
                            title: 'Log Out', icon: LogoutIcon, onClick: () => {
                                localStorage.removeItem('isLogin');
                                localStorage.removeItem('isProfile');
                                handleClickLoading('/')
                            }
                        },
                    ].map((button, index) => (
                        <button
                            key={index}
                            onClick={button.onClick}
                            onMouseOver={() => { setFill('#212121'); setHoveredIndex(index); }}
                            onMouseOut={() => { setFill('#ffffff'); setHoveredIndex(null); }}

                            className='hover:bg-[#22BDE2] group flex gap-2 w-full p-2 rounded-md'
                        >
                            <button.icon className="h-6 w-6" fill={hoveredIndex === index ? '#212121' : isDarkMode ? '#ffffff' : '#000000'} />
                            <span className="group-hover:text-[#212121] text-base line-clamp-1 text-left">{button.title}</span>
                        </button>
                    ))

                    :
                    [
                        { title: 'Pencarian', icon: SearchIcon, onClick: () => { dispatch(searchAction(true)) } },
                        { title: 'Cek Pesanan', icon: TransactionIcon, onClick: () => { handleClickLoading('/cek-invoice'); } },
                        { title: 'Cek Region Mobile Legends', icon: SearchIcon, onClick: () => { handleClickLoading('/check-ml'); } },

                        {
                            title: 'Login', icon: LoginIcon, onClick: () => {
                                handleClickLoading('/login')
                                localStorage.setItem('isChoosePage', ('Masuk'));
                            }
                        },
                        {
                            title: 'Register', icon: RegisterIcon, onClick: () => {
                                handleClickLoading('/login')
                                localStorage.setItem('isChoosePage', ('Daftar'));
                            }
                        },
                    ].map((button, index) => (
                        <button
                            key={index}
                            onClick={button.onClick}
                            onMouseOver={() => { setFill('#212121'); setHoveredIndex(index); }}
                            onMouseOut={() => { setFill('#ffffff'); setHoveredIndex(null); }}

                            className='hover:bg-[#22BDE2] group flex gap-2 w-full p-2 rounded-md'
                        >
                            <button.icon className="h-6 w-6" fill={hoveredIndex === index ? '#212121' : isDarkMode ? '#212121' : '#000000'} />
                            <span className="group-hover:text-[#212121] text-base line-clamp-1 text-left">{button.title}</span>
                        </button>
                    ))
                }

            </div>

        </div>
    );
}

export default Sidebar;
